import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "@/api/client";
import { ArrowLeft, Send } from "lucide-react";
import Avatar from "@/components/Avatar";
import { usePortalAuth } from "@/contexts/PortalAuthContext";

export default function PortalTicketDetail() {
  const { tid } = useParams(); const nav = useNavigate(); const { customer } = usePortalAuth();
  const [data, setData] = useState(null); const [reply, setReply] = useState("");
  const load = () => apiClient.get(`/portal/tickets/${tid}`).then(r => setData(r.data));
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [tid]);
  const send = async () => { if (!reply.trim()) return; await apiClient.post(`/portal/tickets/${tid}/reply`, { body: reply }); setReply(""); load(); };
  if (!data) return <div className="text-sm text-[#94A3B8]">Yükleniyor…</div>;

  return (
    <div className="space-y-5" data-testid="portal-ticket-detail">
      <button onClick={() => nav("/portal/destek")} className="ky-btn ky-btn-ghost ky-btn-sm"><ArrowLeft size={12}/>Tüm Talepler</button>
      <div className="ky-card p-5">
        <div className="flex items-center gap-2"><span className={`ky-badge ${data.ticket.status==='open'?'ky-badge-warning':data.ticket.status==='closed'?'ky-badge-neutral':'ky-badge-info'}`}>{data.ticket.status}</span></div>
        <h1 className="text-xl font-bold mt-2">{data.ticket.subject}</h1>
        <div className="text-xs text-[#94A3B8] mt-1">Açılma: {new Date(data.ticket.created_at).toLocaleString("tr-TR")}</div>
      </div>
      <div className="space-y-3">
        {data.messages.map(m => (
          <div key={m.id} className={`flex gap-3 ${m.author_type === "customer" ? "flex-row-reverse" : ""}`}>
            <Avatar name={m.author_name} size={32}/>
            <div className={`max-w-[80%] ky-card p-4 ${m.author_type === "customer" ? "bg-[#EEF2FF] border-[#C7D2FE]" : ""}`}>
              <div className="text-xs font-semibold mb-1.5">{m.author_name} <span className="text-[10px] text-[#94A3B8] font-normal ml-2">{new Date(m.created_at).toLocaleString("tr-TR")}</span></div>
              <div className="text-sm whitespace-pre-wrap leading-relaxed">{m.body}</div>
            </div>
          </div>
        ))}
      </div>
      {data.ticket.status !== "closed" && (
        <div className="ky-card p-4">
          <textarea value={reply} onChange={e=>setReply(e.target.value)} placeholder="Yanıtınızı yazın…" className="ky-textarea" rows={4} data-testid="portal-reply-input"/>
          <div className="mt-3 flex justify-end"><button onClick={send} className="ky-btn ky-btn-accent" data-testid="portal-reply-send"><Send size={13}/>Gönder</button></div>
        </div>
      )}
    </div>
  );
}
